export const GET_INBOX = 'GET_INBOX';
export const RECEIVED_INBOX = 'USER_DATA_RECEIVED';
export const DISMISS_INBOX_CARD = 'DISMISS_NOTIFICATION';
export const INBOX_CARD_DISMISSED = 'INBOX_CARD_DISMISSED';
export const CREATE_LOCAL_NOTIFICATION = 'CREATE_LOCAL_NOTIFICATION';
export const ERROR_RECEIVED_FROM_API = 'INBOX_API_ERROR_RECEIVED';
